import React from "react";

const Wind = ({ handlewind }) => {
	return (
		<div>
			<svg viewBox="0 0 494 494" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g
					id="496c312d-f50d-45ac-bafd-57f2f5ef7b71_pixelied-in-october-we-wear-pink 1"
					clip-path="url(#clip0_0_1)"
				>
					<path
						id="Vector"
						d="M361.207 454.6V230.462C361.207 179.624 318.286 139.523 267.432 139.523H226.52C175.674 139.523 132.777 179.624 132.777 230.462V454.6H361.207Z"
						fill="#148DE0"
					/>
					<g id="Group">
						<path
							id="Vector_2"
							d="M361.207 454.6V230.462C361.207 179.624 318.286 139.523 267.432 139.523H226.52C175.674 139.523 135.321 179.223 135.321 230.06"
							fill="#0C76BF"
						/>
						<path
							id="Vector_3"
							d="M187.529 356.13C187.529 359.202 185.056 360.076 181.984 360.076H159.172C156.116 360.076 153.635 359.202 153.635 356.13C153.635 353.074 156.116 352.199 159.172 352.199H181.984C185.056 352.2 187.529 353.074 187.529 356.13Z"
							fill="#0C76BF"
						/>
						<path
							id="Vector_4"
							d="M187.529 403.392C187.529 406.456 185.056 407.338 181.984 407.338H159.172C156.116 407.338 153.635 406.456 153.635 403.392C153.635 400.328 156.116 399.461 159.172 399.461H181.984C185.056 399.461 187.529 400.328 187.529 403.392Z"
							fill="#0C76BF"
						/>
						<path
							id="Vector_5"
							d="M203.669 371.892C203.669 374.066 201.905 375.83 199.731 375.83H176.1C173.926 375.83 172.162 374.066 172.162 371.892C172.162 369.718 173.926 367.954 176.1 367.954H199.731C201.904 367.954 203.669 369.718 203.669 371.892Z"
							fill="#0C76BF"
						/>
					</g>
					<g id="Group_2">
						<path
							id="Vector_6"
							d="M329.699 316.754C329.699 318.928 327.935 320.692 325.761 320.692H302.13C299.956 320.692 298.192 318.928 298.192 316.754C298.192 314.58 299.956 312.816 302.13 312.816H325.761C327.935 312.815 329.699 314.58 329.699 316.754Z"
							fill="#148DE0"
						/>
						<path
							id="Vector_7"
							d="M345.619 348.254C345.619 351.318 343.146 352.2 340.082 352.2H317.27C314.214 352.2 311.733 351.318 311.733 348.254C311.733 345.198 314.214 344.323 317.27 344.323H340.082C343.145 344.323 345.619 345.197 345.619 348.254Z"
							fill="#148DE0"
						/>
					</g>
					<g id="circle" style={handlewind}>
						<path
							id="Vector_8"
							d="M221.993 232.558C229.646 246.562 246.959 251.843 260.662 244.355C274.366 236.866 279.271 219.442 271.618 205.438C263.965 191.434 246.652 186.153 232.948 193.641C219.245 201.13 214.34 218.554 221.993 232.558Z"
							fill="#465453"
						/>
						<path
							id="Vector_9"
							d="M259.214 212.217C252.762 200.409 239.472 194.917 227.234 197.921C218.102 206.596 215.541 220.75 221.993 232.557C228.446 244.365 241.742 249.853 253.974 246.852C263.116 238.172 265.667 224.024 259.214 212.217Z"
							fill="#2B3534"
						/>
						<path
							id="Vector_10"
							d="M256.044 221.774C256.802 219.083 259.569 217.563 262.234 218.376L343.868 243.285C346.533 244.098 348.077 246.924 347.317 249.624C346.568 252.302 343.797 253.817 341.132 253.004L259.504 228.092C256.83 227.276 255.283 224.459 256.044 221.774Z"
							fill="#2B3534"
						/>
						<path
							id="Vector_11"
							d="M303.52 298.212C295.525 295.773 290.88 287.274 293.148 279.233L304.334 239.499C306.591 231.451 312.963 233.848 320.958 236.287L423.497 267.573C431.491 270.012 436.132 278.529 433.871 286.558L424.644 319.349C422.382 327.386 414.068 331.937 406.067 329.501L303.52 298.212Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_12"
							d="M307.278 284.863L409.822 316.133C417.823 318.583 426.14 314.038 428.405 305.992L433.871 286.559C436.132 278.53 431.491 270.013 423.496 267.574L320.957 236.289C312.962 233.85 306.596 231.449 304.334 239.5L296.906 265.886C294.643 273.907 299.279 282.404 307.278 284.863Z"
							fill="#FF7C24"
						/>
						<g id="Group_3">
							<path
								id="Vector_13"
								d="M394.546 317.642C392.769 317.095 391.736 315.192 392.237 313.415L395.891 300.469C396.39 298.678 398.233 297.671 400.016 298.215C401.799 298.759 402.832 300.648 402.334 302.43L398.683 315.382C398.174 317.155 396.323 318.174 394.546 317.642Z"
								fill="#FFA522"
							/>
							<path
								id="Vector_14"
								d="M379.672 313.104C377.893 312.566 376.857 310.671 377.359 308.871L381.008 295.928C381.514 294.149 383.362 293.138 385.141 293.677C386.915 294.218 387.954 296.104 387.442 297.887L383.8 310.842C383.291 312.615 381.443 313.64 379.672 313.104Z"
								fill="#FFA522"
							/>
							<path
								id="Vector_15"
								d="M364.795 308.561C363.012 308.017 361.979 306.114 362.485 304.334L366.127 291.38C366.635 289.591 368.487 288.587 370.264 289.134C372.035 289.669 373.073 291.556 372.576 293.352L368.919 306.292C368.423 308.089 366.569 309.102 364.795 308.561Z"
								fill="#FFA522"
							/>
						</g>
						<path
							id="Vector_16"
							d="M237.575 216.224C236.823 218.912 234.041 220.432 231.372 219.613L149.747 194.707C147.083 193.894 145.535 191.063 146.284 188.369C147.039 185.687 149.81 184.173 152.48 184.983L234.117 209.898C236.777 210.714 238.327 213.537 237.575 216.224Z"
							fill="#2B3534"
						/>
						<path
							id="Vector_17"
							d="M190.096 139.781C198.096 142.217 202.739 150.725 200.473 158.756L189.287 198.491C187.022 206.537 180.667 204.13 172.664 201.702L70.1249 170.417C62.1244 167.981 57.4813 159.458 59.7501 151.432L68.9848 118.643C71.2501 110.611 79.5618 106.069 87.5621 108.491L190.096 139.781Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_18"
							d="M186.335 153.139L83.7991 121.858C75.7954 119.416 67.4781 123.961 65.2191 132.005L59.7532 151.438C57.4848 159.464 62.1275 167.986 70.1281 170.422L172.667 201.708C180.67 204.135 187.029 206.548 189.29 198.496L196.718 172.112C198.981 164.074 194.339 155.58 186.335 153.139Z"
							fill="#FF7C24"
						/>
						<path
							id="Vector_19"
							d="M99.0688 120.351C100.846 120.898 101.882 122.793 101.367 124.584L97.7302 137.521C97.2307 139.312 95.3875 140.319 93.6047 139.776C91.8218 139.232 90.7918 137.333 91.295 135.563L94.9383 122.608C95.4472 120.835 97.2897 119.813 99.0688 120.351Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_20"
							d="M113.944 124.889C115.724 125.442 116.759 127.336 116.26 129.127L112.609 142.079C112.106 143.85 110.257 144.86 108.477 144.322C106.697 143.784 105.658 141.883 106.167 140.109L109.813 127.16C110.321 125.373 112.173 124.354 113.944 124.889Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_21"
							d="M128.82 129.432C130.603 129.976 131.639 131.871 131.13 133.659L127.485 146.608C126.982 148.393 125.134 149.404 123.351 148.859C121.577 148.318 120.545 146.429 121.047 144.643L124.696 131.7C125.193 129.904 127.047 128.891 128.82 129.432Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_22"
							d="M244.24 228.291C246.908 229.11 248.456 231.941 247.701 234.623L224.574 316.775C223.816 319.451 221.039 320.968 218.374 320.155C215.706 319.337 214.165 316.516 214.917 313.829L238.05 231.674C238.802 228.986 241.569 227.466 244.24 228.291Z"
							fill="#2B3534"
						/>
						<path
							id="Vector_23"
							d="M169.538 274.936C171.798 266.893 180.129 262.347 188.116 264.784L227.59 276.826C235.599 279.265 233.33 285.655 231.071 293.698L202.017 396.905C199.752 404.951 191.429 409.499 183.434 407.06L150.861 397.119C142.87 394.685 138.221 386.18 140.492 378.131L169.538 274.936Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_24"
							d="M182.806 278.988L153.768 382.186C151.488 390.233 156.139 398.729 164.128 401.171L183.427 407.063C191.422 409.502 199.745 404.954 202.01 396.908L231.07 293.698C233.329 285.655 235.598 279.264 227.589 276.826L201.394 268.83C193.388 266.397 185.076 270.939 182.806 278.988Z"
							fill="#FF7C24"
						/>
						<g id="Group_4">
							<path
								id="Vector_25"
								d="M152 366.707C152.502 364.907 154.35 363.896 156.136 364.446L168.999 368.366C170.773 368.907 171.806 370.796 171.304 372.596C170.795 374.384 168.958 375.388 167.178 374.85L154.311 370.925C152.538 370.384 151.491 368.495 152 366.707Z"
								fill="#FFA522"
							/>
							<path
								id="Vector_26"
								d="M156.21 351.732C156.715 349.938 158.575 348.922 160.346 349.472L173.207 353.386C174.993 353.935 176.017 355.822 175.511 357.616C175.005 359.395 173.16 360.411 171.384 359.879L158.52 355.945C156.744 355.412 155.708 353.517 156.21 351.732Z"
								fill="#FFA522"
							/>
							<path
								id="Vector_27"
								d="M160.433 336.765C160.935 334.965 162.793 333.958 164.569 334.505L177.424 338.422C179.201 338.954 180.233 340.844 179.728 342.638C179.223 344.432 177.38 345.439 175.603 344.892L162.733 340.976C160.966 340.431 159.928 338.545 160.433 336.765Z"
								fill="#FFA522"
							/>
						</g>
						<path
							id="Vector_28"
							d="M249.378 209.708C246.701 208.887 245.16 206.053 245.918 203.376L269.036 121.222C269.796 118.537 272.572 117.02 275.238 117.832C277.909 118.657 279.447 121.486 278.698 124.165L255.566 206.319C254.819 209.004 252.054 210.515 249.378 209.708Z"
							fill="#2B3534"
						/>
						<path
							id="Vector_29"
							d="M324.083 163.054C321.821 171.106 313.495 175.635 305.509 173.212L266.021 161.17C258.029 158.722 260.284 152.347 262.557 144.289L291.603 41.0932C293.865 33.0416 302.197 28.4959 310.186 30.938L342.764 40.8766C350.756 43.3099 355.401 51.8096 353.136 59.8701L324.083 163.054Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_30"
							d="M310.801 159.002L339.851 55.8117C342.127 47.7596 337.485 39.2657 329.491 36.8267L310.186 30.938C302.197 28.4959 293.871 33.0385 291.603 41.0933L262.556 144.289C260.283 152.347 258.028 158.722 266.02 161.17L292.235 169.162C300.222 171.599 308.539 167.054 310.801 159.002Z"
							fill="#FF7C24"
						/>
						<path
							id="Vector_31"
							d="M341.616 71.2863C341.111 73.0805 339.262 74.0909 337.486 73.5435L324.621 69.6244C322.844 69.0774 321.812 67.188 322.317 65.3945C322.817 63.6033 324.672 62.6045 326.443 63.14L339.316 67.0767C341.086 67.6119 342.127 69.5039 341.616 71.2863Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_32"
							d="M337.405 86.261C336.9 88.0553 335.048 89.0599 333.274 88.5183L320.416 84.5957C318.63 84.046 317.604 82.1682 318.11 80.3746C318.621 78.5919 320.47 77.5816 322.24 78.1174L335.107 82.0427C336.872 82.5805 337.907 84.4756 337.405 86.261Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_33"
							d="M333.191 101.23C332.695 103.027 330.834 104.028 329.06 103.487L316.2 99.5731C314.426 99.0319 313.39 97.1368 313.899 95.349C314.398 93.5578 316.253 92.5444 318.021 93.0887L330.882 97.0024C332.658 97.5502 333.693 99.4453 333.191 101.23Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_34"
							d="M234.74 225.591C238.461 232.401 246.88 234.969 253.543 231.328C260.206 227.686 262.591 219.214 258.87 212.405C255.149 205.595 246.731 203.027 240.067 206.668C233.404 210.31 231.019 218.782 234.74 225.591Z"
							fill="#FFA522"
						/>
						<path
							id="Vector_35"
							d="M260.102 223.05C258.023 230.448 250.389 234.62 243.045 232.371C235.707 230.132 231.439 222.334 233.517 214.935"
							fill="#FF7C24"
						/>
					</g>
					<path
						id="Vector_36"
						d="M434.722 474.3C434.722 485.099 449.436 493.984 438.637 493.984H55.33C44.523 493.984 59.237 485.099 59.237 474.3C59.237 463.493 67.988 454.6 78.795 454.6H415.163C425.979 454.6 434.722 463.493 434.722 474.3Z"
						fill="#559913"
					/>
					<path
						id="Vector_37"
						d="M415.172 454.6H78.796C68.209 454.6 59.647 462.477 59.293 470.354H434.66C434.321 462.477 425.751 454.6 415.172 454.6Z"
						fill="#7DA81D"
					/>
				</g>
				<defs>
					<clipPath id="clip0_0_1">
						<rect width="493.984" height="493.984" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};

export default Wind;
